module.exports = __webpack_public_path__ + "static/media/productos.bc815f86.webp";